import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	commentIconLabel: {
		id: 'dynamic-cards-search-page.comment-icon.label',
		defaultMessage: 'Number of comments',
		description: 'Accessibility label for the comment count icon',
	},
});
